module.exports = __webpack_public_path__ + "static/media/home-arrow.f70d1564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-arrow.svg
// module id = 1903
// module chunks = 0